// The top bar's icon button: ghost, 32px, with a tooltip carrying its label. Every prop (ref and the
// trigger props a wrapping Radix `asChild` adds) goes to the button, so it can sit inside a
// PopoverTrigger or DropdownMenuTrigger.
import type * as React from 'react';

import { Button } from '@/components/lumen/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/lumen/tooltip';
import { cn } from '@/lib/utils';

export function TopbarIconButton({
  label,
  className,
  children,
  ...props
}: React.ComponentProps<'button'> & { label: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-sm"
          aria-label={label}
          className={cn('text-fg-2 data-[state=open]:bg-tint data-[state=open]:text-fg', className)}
          {...props}
        >
          {children}
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" sideOffset={4}>
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
